// extracted by mini-css-extract-plugin
module.exports = {"container":"KitReportNotes_container__SM2kl"};